import { Notifications, type NotificationsProps } from '@any-ui-react/notifications';

type ToasterProps = NotificationsProps;

export const Toaster = (props: ToasterProps) => <Notifications containerWidth={326} position="top-right" {...props} />;
